import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import GatewayContent from './GatewayContent';

export default function PaymentGateway() {
  return (
    <CasinoContainer title={'Crypto gateway settings'}>
      <GatewayContent />
    </CasinoContainer>
  );
}
